export enum UwSummarySection {
  UnderwritingInformation = 'UnderwritingInformation',
}

export type IUwSummaryConfig = Record<UwSummarySection, Record<string, { visible: boolean }>>
